import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

type StyledButtonProps = {
  right?: boolean
}

const shouldForwardProp = (prop: string) => !['right'].includes(prop)

const styledButtonRightCss = ({ right }: StyledButtonProps) =>
  right &&
  css`
    left: unset;
    right: 0;
  `

export const StyledButton = styled.button.withConfig({
  shouldForwardProp,
})<StyledButtonProps>`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${themeGet('colors.primary.main')};
  z-index: 100;

  ${styledButtonRightCss}
`
